export class SalesPerson {
  public constructor() {

  }

  public SlsPersonID: string;

  public Name: string;
}
